// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OsvrtiOcjeneNaMojRad_wrapper__DGvGk,
.OsvrtiOcjeneNaMojRad_emptyContainer__G8Rx4 {
  width: 100%;
}
.OsvrtiOcjeneNaMojRad_wrapper__DGvGk,
.OsvrtiOcjeneNaMojRad_commentWrapper__2L4OD,
.OsvrtiOcjeneNaMojRad_ratingColumn__EhheL {
  align-items: baseline;
}
.OsvrtiOcjeneNaMojRad_commentWrapper__2L4OD {
  width: 100%;
  border-bottom: 1px solid #e2e2e2;
}
.OsvrtiOcjeneNaMojRad_ratingColumn__EhheL {
  width: 50%;
  gap: 24px;
  margin-top: 32px;
}
.OsvrtiOcjeneNaMojRad_backRow__dtd23 {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  transition: -webkit-text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out, -webkit-text-decoration 300ms ease-in-out;
}
.OsvrtiOcjeneNaMojRad_backRow__dtd23:hover {
  text-decoration: underline;
  cursor: pointer;
}
.OsvrtiOcjeneNaMojRad_back__02xva {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.001em;
  color: #5f6d7e;
}
.OsvrtiOcjeneNaMojRad_firstColumn__aiXU7 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
}
.OsvrtiOcjeneNaMojRad_voditeljRow__nfBic {
  display: flex;
  gap: 20px;
}
.OsvrtiOcjeneNaMojRad_wrapper__DGvGk,
.OsvrtiOcjeneNaMojRad_ratingWrapper__AxyPv,
.OsvrtiOcjeneNaMojRad_ratingColumn__EhheL,
.OsvrtiOcjeneNaMojRad_commentWrapper__2L4OD {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.OsvrtiOcjeneNaMojRad_ratingWrapper__AxyPv {
  align-items: center;
  border: 1px solid #d1d9e2;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border-radius: 10px;
  width: 100%;
  padding: 12px;
}
.OsvrtiOcjeneNaMojRad_avatar__X08tp {
  width: 88px;
  height: 88px;
  border-radius: 100px;
}
.OsvrtiOcjeneNaMojRad_avatarName__k2kJP,
.OsvrtiOcjeneNaMojRad_avatarRole__57U0B,
.OsvrtiOcjeneNaMojRad_title__vnYJQ,
.OsvrtiOcjeneNaMojRad_navigationRow__-Ue24,
.OsvrtiOcjeneNaMojRad_emptySpan__Y11hx {
  font-family: Inter;
  letter-spacing: -0.001em;
  text-align: left;
}
.OsvrtiOcjeneNaMojRad_avatarName__k2kJP,
.OsvrtiOcjeneNaMojRad_avatarRole__57U0B {
  color: #4d4d4d;
}
.OsvrtiOcjeneNaMojRad_avatarName__k2kJP {
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
}
.OsvrtiOcjeneNaMojRad_avatarRole__57U0B {
  font-weight: 500;
}
.OsvrtiOcjeneNaMojRad_avatarRole__57U0B,
.OsvrtiOcjeneNaMojRad_title__vnYJQ {
  font-size: 16px;
  line-height: 22px;
}
.OsvrtiOcjeneNaMojRad_row__JPtMS {
  margin-top: 16px;
  gap: 16px;
}
.OsvrtiOcjeneNaMojRad_row__JPtMS,
.OsvrtiOcjeneNaMojRad_emptyContainer__G8Rx4 {
  justify-content: flex-start;
}
.OsvrtiOcjeneNaMojRad_title__vnYJQ {
  font-weight: 600;
  text-align: center;
  color: #5f6d7e;
}
.OsvrtiOcjeneNaMojRad_row__JPtMS,
.OsvrtiOcjeneNaMojRad_navigationRow__-Ue24,
.OsvrtiOcjeneNaMojRad_emptyContainer__G8Rx4 {
  display: flex;
  align-items: center;
}
.OsvrtiOcjeneNaMojRad_navigationRow__-Ue24 {
  justify-content: center;
  gap: 16px;
  margin-bottom: 32px;
  margin-top: -16px;
}
.OsvrtiOcjeneNaMojRad_navigationRow__-Ue24,
.OsvrtiOcjeneNaMojRad_emptySpan__Y11hx {
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #5f6d7e;
}
.OsvrtiOcjeneNaMojRad_navigationRow__-Ue24:hover {
  cursor: pointer;
  text-decoration: underline;
}
.OsvrtiOcjeneNaMojRad_backArrow__-31\\+H {
  width: 24px;
  height: 24px;
}
.OsvrtiOcjeneNaMojRad_emptyContainer__G8Rx4 {
  padding: 32px;
  border: 2px solid #e2e2e2;
  border-radius: 8px;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  background-color: #fcfcfc;
  box-sizing: border-box;
  margin-top: 24px;
}

@media screen and (max-width: 800px) {
  .OsvrtiOcjeneNaMojRad_ratingColumn__EhheL {
    width: 98%;
    box-sizing: border-box;
    padding-right: 15px;
  }
  .OsvrtiOcjeneNaMojRad_row__JPtMS {
    justify-content: space-around;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/OsvrtiNaVoditelja/components/OsvrtiOcjeneNaMojRad/OsvrtiOcjeneNaMojRad.module.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;AACb;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,qDAA6C;EAA7C,6CAA6C;EAA7C,wFAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;;;;;EAKE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".wrapper,\n.emptyContainer {\n  width: 100%;\n}\n.wrapper,\n.commentWrapper,\n.ratingColumn {\n  align-items: baseline;\n}\n.commentWrapper {\n  width: 100%;\n  border-bottom: 1px solid #e2e2e2;\n}\n.ratingColumn {\n  width: 50%;\n  gap: 24px;\n  margin-top: 32px;\n}\n.backRow {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 16px;\n  transition: text-decoration 300ms ease-in-out;\n}\n.backRow:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.back {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n}\n.firstColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n.voditeljRow {\n  display: flex;\n  gap: 20px;\n}\n.wrapper,\n.ratingWrapper,\n.ratingColumn,\n.commentWrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.ratingWrapper {\n  align-items: center;\n  border: 1px solid #d1d9e2;\n  box-shadow: 0px 1px 2px 0px #1018280d;\n  border-radius: 10px;\n  width: 100%;\n  padding: 12px;\n}\n.avatar {\n  width: 88px;\n  height: 88px;\n  border-radius: 100px;\n}\n.avatarName,\n.avatarRole,\n.title,\n.navigationRow,\n.emptySpan {\n  font-family: Inter;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n.avatarName,\n.avatarRole {\n  color: #4d4d4d;\n}\n.avatarName {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n}\n.avatarRole {\n  font-weight: 500;\n}\n.avatarRole,\n.title {\n  font-size: 16px;\n  line-height: 22px;\n}\n.row {\n  margin-top: 16px;\n  gap: 16px;\n}\n.row,\n.emptyContainer {\n  justify-content: flex-start;\n}\n.title {\n  font-weight: 600;\n  text-align: center;\n  color: #5f6d7e;\n}\n.row,\n.navigationRow,\n.emptyContainer {\n  display: flex;\n  align-items: center;\n}\n.navigationRow {\n  justify-content: center;\n  gap: 16px;\n  margin-bottom: 32px;\n  margin-top: -16px;\n}\n.navigationRow,\n.emptySpan {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  color: #5f6d7e;\n}\n.navigationRow:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.backArrow {\n  width: 24px;\n  height: 24px;\n}\n.emptyContainer {\n  padding: 32px;\n  border: 2px solid #e2e2e2;\n  border-radius: 8px;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  background-color: #fcfcfc;\n  box-sizing: border-box;\n  margin-top: 24px;\n}\n\n@media screen and (max-width: 800px) {\n  .ratingColumn {\n    width: 98%;\n    box-sizing: border-box;\n    padding-right: 15px;\n  }\n  .row {\n    justify-content: space-around;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `OsvrtiOcjeneNaMojRad_wrapper__DGvGk`,
	"emptyContainer": `OsvrtiOcjeneNaMojRad_emptyContainer__G8Rx4`,
	"commentWrapper": `OsvrtiOcjeneNaMojRad_commentWrapper__2L4OD`,
	"ratingColumn": `OsvrtiOcjeneNaMojRad_ratingColumn__EhheL`,
	"backRow": `OsvrtiOcjeneNaMojRad_backRow__dtd23`,
	"back": `OsvrtiOcjeneNaMojRad_back__02xva`,
	"firstColumn": `OsvrtiOcjeneNaMojRad_firstColumn__aiXU7`,
	"voditeljRow": `OsvrtiOcjeneNaMojRad_voditeljRow__nfBic`,
	"ratingWrapper": `OsvrtiOcjeneNaMojRad_ratingWrapper__AxyPv`,
	"avatar": `OsvrtiOcjeneNaMojRad_avatar__X08tp`,
	"avatarName": `OsvrtiOcjeneNaMojRad_avatarName__k2kJP`,
	"avatarRole": `OsvrtiOcjeneNaMojRad_avatarRole__57U0B`,
	"title": `OsvrtiOcjeneNaMojRad_title__vnYJQ`,
	"navigationRow": `OsvrtiOcjeneNaMojRad_navigationRow__-Ue24`,
	"emptySpan": `OsvrtiOcjeneNaMojRad_emptySpan__Y11hx`,
	"row": `OsvrtiOcjeneNaMojRad_row__JPtMS`,
	"backArrow": `OsvrtiOcjeneNaMojRad_backArrow__-31+H`
};
export default ___CSS_LOADER_EXPORT___;
